import { createFileRoute } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { PageWrapper } from '@/shared/ui/page-wrapper'
import { PathCard } from '@/shared/ui/path-card'

export const Route = createFileRoute('/_auth/administration/')({
  staticData: {
    meta: {
      title: 'Администрирование',
      description: '',
    },
  },
  component: RouteComponent,
})

function RouteComponent() {
  const { t } = useTranslation()
  return (
    <PageWrapper title={t('Администрирование')}>
      <PathCard path="/administration/reference-books" title={t('Справочники')} />
      <PathCard path="/administration/settings" title={t('Настраиваемые параметры')} />
      <PathCard path="/administration/monitoring/processes" title={t('Мониторинг')} />
    </PageWrapper>
  )
}
